import { VehicleApiErrorType } from "./get-vehicle-brochure";

export enum VehicleCardType {
  Primary = "Primary",
  SimilarNew = "SimilarNew",
  SimilarUsed = "SimilarUsed",
  SimilarMixed = "SimilarMixed"
}

export interface GetVehicleCardRequest {
  dealerId: number;
  consumerId: string;
  autoLeadId: number;
  consumerRecordSystem?: string;
  cardType: VehicleCardType;
}

export interface GetVehicleCardResponse {
  body?: string;
  errorType?: VehicleApiErrorType;
}
